import {
  NoProductsScreen,
  PhoneSubmitScreen,
  ProductsCart,
  ProductsScreen,
  PurchaseDataScreen,
  PurchaseDeliveryScreen,
  PurchasePaymentFailedScreen,
  PurchasePaymentSuccessScreen,
  StartLoading,
  StartScreen,
  PaymentWait,
  SurveyFinishScreen,
} from "../Screens";
import React from "react";
import styled from "styled-components";
import StepScreen from "../Screens/StepScreen";
import SummaryBenefitsScreen from "../Screens/SummaryBenefitsScreen";
import { IStep } from "../Steps";
import PurchasePaymentScreen from "../Screens/PurchasePaymentScreen";
import PurchaseInfoScreen from "../Screens/PurchaseInfoScreen";
import FakePayment from "../Screens/FakePayment";
import { useMediaQuery } from "@material-ui/core";
import logo from "../../assets/logo.svg";
import Scrollbars from "react-custom-scrollbars";
import isIframeMode from "../../utils/isIframeMode";

const Fragment = styled.div<{
  $height?: boolean;
  $desktop?: boolean;
  $stacked?: boolean;
}>`
  width: ${({ $desktop, $stacked }) =>
    $stacked ? "100%" : $desktop ? "50%" : "100%"};
  @media (max-width: 800px) {
    height: ${({ $height }) => ($height ? "unset" : "100%")};
    min-height: 100%;
  }
`;

const SplitLayout = styled.div<{ $stacked?: boolean }>`
  display: inline-flex;
  flex-direction: ${({ $stacked }) => ($stacked ? "column" : "row")};
  width: 100%;
  min-height: 100vh;
`;

export const SplitScreen = ({
  leftScreen,
  rightScreen,
  height,
  scroll = true,
  step = undefined,
  iframeStack = false,
}: ISplitScreen) => {
  const desktop = useMediaQuery("(min-width:800px)");
  const iframeMode = isIframeMode();
  const stacked = iframeMode && iframeStack;

  return desktop || stacked ? (
    scroll ? (
      <>
        <Scrollbars
          autoHeight={true}
          autoHide={true}
          autoHeightMin={"100%"}
          renderTrackHorizontal={() => <div style={{ display: "none" }} />}
        >
          <SplitLayout $stacked={stacked}>
            <Fragment
              $height={height}
              style={{ backgroundColor: "#f5f8fc" }}
              $desktop={desktop}
              $stacked={stacked}
            >
              {React.cloneElement(leftScreen, { step: step })}
            </Fragment>
            <Fragment
              $height={height}
              style={{ backgroundColor: "#00a04f" }}
              $desktop={desktop}
              $stacked={stacked}
            >
              {rightScreen}
            </Fragment>
          </SplitLayout>
        </Scrollbars>
      </>
    ) : (
      <SplitLayout $stacked={stacked}>
        <Fragment
          $height={height}
          style={{ backgroundColor: "#f5f8fc" }}
          $desktop={desktop}
          $stacked={stacked}
        >
          {React.cloneElement(leftScreen, { step: step })}
        </Fragment>
        <Fragment
          $height={height}
          style={{ backgroundColor: "#00a04f" }}
          $desktop={desktop}
          $stacked={stacked}
        >
          {rightScreen}
        </Fragment>
      </SplitLayout>
    )
  ) : (
    <div style={{ width: "100%" }}>
      <Fragment
        $height={height}
        style={{ backgroundColor: "#f5f8fc" }}
        $desktop={desktop}
      >
        {React.cloneElement(leftScreen, { step: step })}
      </Fragment>
    </div>
  );
};

const stepsRouter: { [key: string]: React.ReactNode } = {
  start: (
    <SplitScreen
      height={true}
      leftScreen={<StartScreen />}
      rightScreen={
        <div
          style={{
            display: "flex",
            width: "100%",
            height: "100%",
            alignItems: "center",
            justifyContent: "center",
          }}
      >
        <div style={{ width: "100%" }}>
          <img src={logo} alt="" />
        </div>
      </div>
      }
    />
  ),
  startLoading: <StartLoading />,
  finish: <SurveyFinishScreen />,
  noProducts: <NoProductsScreen />,
  phoneSubmit: <PhoneSubmitScreen />,
  products: (
    <SplitScreen
      height={true}
      leftScreen={<ProductsScreen />}
      rightScreen={<SummaryBenefitsScreen />}
      iframeStack={true}
    />
  ),
  productsCart: <ProductsCart />,
  purchaseData: <PurchaseDataScreen />,
  purchasePayment: <PurchasePaymentScreen />,
  purchaseDelivery: <PurchaseDeliveryScreen />,
  purchaseInfo: <PurchaseInfoScreen />,
  paymentFailed: <PurchasePaymentFailedScreen />,
  paymentSuccess: <PurchasePaymentSuccessScreen />,
  fakePayment: <FakePayment />,
  paymentWait: <PaymentWait />,
};

export const Router = new Proxy(stepsRouter, {
  get: (target, p) =>
    p in target ? (
      target[p as string]
    ) : (
      <SplitScreen
        height={true}
        scroll={false}
        leftScreen={<StepScreen />}
        rightScreen={<SummaryBenefitsScreen key={"summaryScreenBenefit"} />}
        iframeStack={true}
      />
    ),
});

export interface ISplitScreen {
  leftScreen: React.ReactNode | any;
  rightScreen: React.ReactNode | any;
  step?: IStep | undefined;
  scroll?: boolean;
  height?: boolean;
  iframeStack?: boolean;
}
